import React from 'react'
import PropTypes from 'prop-types'
import { twMerge as mergeClassNames } from 'tailwind-merge'
import { ExclamationTriangleIcon } from '@heroicons/react/24/solid'

// Why the event is not ready (EXEC-1596). On the event home this surfaces on hover; in
// the dashboard's event list the cell's own click overlay sits above the badge, so the
// full explanation there is the setup flow itself, which opens on arrival.
export const NEEDS_SETUP_REASON =
  'Setup is not complete for this company: the event contact must be confirmed and licenses purchased.'

/**
 *
 * NeedsSetupBadge
 *
 * Marks an event a company has not finished setting up — the exhibitor's own
 * `EventExhibitor.status`, which is separate from the event's date-driven status, so the
 * two sit side by side (an event can be Upcoming and still need setup).
 *
 * Solid rather than tinted: it shares a row with the event's status pill, and a second
 * tinted pill reads as level with the first instead of drawing the eye. The row it sits
 * on keeps its full weight — the event is still open to anyone with access, and dimming
 * it would read as disabled.
 */
const NeedsSetupBadge = ({ className }) => (
  <div
    className={mergeClassNames(
      'flex shrink-0 flex-row place-items-center space-x-1 rounded-full bg-warning px-2.5 py-0.5',
      className,
    )}
    title={NEEDS_SETUP_REASON}
  >
    <ExclamationTriangleIcon className="h-3.5 w-3.5 shrink-0 text-white" />

    <span className="whitespace-nowrap text-xs font-bold text-white" data-tag="allowRowEvents">
      Needs Setup
    </span>
  </div>
)

NeedsSetupBadge.defaultProps = {
  className: null,
}

NeedsSetupBadge.propTypes = {
  className: PropTypes.string,
}

export default NeedsSetupBadge
